module.exports = __webpack_public_path__ + "static/img/logo-light.ac4d15de.png";